import React, { useEffect, useMemo } from 'react';
import {
	createRecordPathCodec,
	NavbarType,
	QuickbaseIFrameContainer,
	quickbaseNavbarStoreSelector,
	recordPathSegmentFor,
	recordPresentationFor,
	useAdminStore,
	useQuickbaseHostBridgeSync,
} from '@warehouse/quickbase';
import styled, { css } from 'styled-components';
import Card from '../../components/library/Card';

export function AdminQuickbase() {
	const isLoading = useAdminStore(quickbaseNavbarStoreSelector.isLoading);
	const isAuthenticated = useAdminStore(quickbaseNavbarStoreSelector.isAuthenticated);
	const error = useAdminStore(quickbaseNavbarStoreSelector.error);
	const embedUrl = useAdminStore(quickbaseNavbarStoreSelector.embedUrl);
	const frameUrl = useAdminStore(quickbaseNavbarStoreSelector.frameUrl);
	const showAuthOverlay = useAdminStore(quickbaseNavbarStoreSelector.showAuthOverlay);
	const authFlow = useAdminStore(quickbaseNavbarStoreSelector.authFlow);
	const actions = useAdminStore(quickbaseNavbarStoreSelector.actions);
	const { loadEmbedUrl, authenticate, setShowAuthOverlay, dismissAuthOverlay, recoverSession } = actions;

	const codec = useMemo(
		() =>
			createRecordPathCodec({
				resolveBasePath: () => '/admin',
				recordSegment: recordPathSegmentFor(NavbarType.Admin),
			}),
		[],
	);

	const { bridge, initialEmbedParams, reloadToken } = useQuickbaseHostBridgeSync({
		embedUrl,
		codec,
		reloadEmbedUrl: loadEmbedUrl,
		presentation: recordPresentationFor(NavbarType.Admin),
	});

	useEffect(() => {
		loadEmbedUrl(initialEmbedParams);
	}, [loadEmbedUrl, initialEmbedParams]);

	return (
		<Wrapper>
			<CardWrapper>
				<Card sx={{ minWidth: 275, overflow: 'hidden', height: '100%' }}>
					<QuickbaseIFrameContainer
						isLoading={isLoading}
						isAuthenticated={isAuthenticated}
						error={error}
						embedUrl={embedUrl}
						frameUrl={frameUrl}
						showAuthOverlay={showAuthOverlay}
						authenticate={authenticate}
						setShowAuthOverlay={setShowAuthOverlay}
						dismissAuthOverlay={dismissAuthOverlay}
						recoverSession={recoverSession}
						authFlow={authFlow}
						iFrameType="Admin"
						bridge={bridge}
						reloadToken={reloadToken}
					/>
				</Card>
			</CardWrapper>
		</Wrapper>
	);
}
// Styled components
const Wrapper = styled.div(
	() => css`
		background-color: #dde0e3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		width: 100%;
	`,
);

const CardWrapper = styled.div(
	({ theme }) => css`
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: ${theme.spacing(2)};
		padding: ${theme.spacing(2)};
		width: 100%;
	`,
);
